/**
 * Wishlist Share utilities.
 *
 * Share your saved/favourite listings as a public shareable URL.
 *
 * Wishlists stored in user.publicData.wishlists = [
 *   { id: string, name: string, listingIds: string[], isPublic: boolean, shareCode: string }
 * ]
 *
 * Share URL: /wishlist/{shareCode}
 */

const SHARE_CODE_LENGTH = 8;

/**
 * Generate a random share code.
 * @returns {string}
 */
export const generateShareCode = () => {
  const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let code = '';
  for (let i = 0; i < SHARE_CODE_LENGTH; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
};

/**
 * Build share URL for a wishlist.
 * @param {string} shareCode
 * @param {string} [baseUrl]
 * @returns {string}
 */
export const buildShareUrl = (shareCode, baseUrl = '') =>
  `${baseUrl.replace(/\/$/, '')}/wishlist/${shareCode}`;

/**
 * Get wishlists from user.
 * @param {Object|null} user
 * @returns {Object[]}
 */
export const getUserWishlists = (user) =>
  user?.attributes?.publicData?.wishlists || [];

/**
 * Find wishlist by share code.
 * @param {Object[]} wishlists
 * @param {string} shareCode
 * @returns {Object|null}
 */
export const findWishlistByCode = (wishlists, shareCode) =>
  wishlists.find(w => w.shareCode === shareCode && w.isPublic) || null;

/**
 * Validate wishlist name.
 * @param {string} name
 * @returns {string|null}
 */
export const validateWishlistName = (name) => {
  if (!name?.trim()) return 'Name is required';
  if (name.trim().length > 100) return 'Name must be under 100 characters';
  return null;
};
